import {api, headers} from './api';

const RESOURCE = 'dm_luaran_tambahan_kategori';

export const indexLuaranTambahanKategori = (id)=> api.get(RESOURCE+'?luaran_tambahan_id='+id, headers)

export const storeLuaranTambahanKategori = (data) => api.post(RESOURCE, data, headers)